import { themeTokensGQLFields, } from './themeTokens.fields.js';
const BASIC_THEME_TOKENS_FIELDS = {};
const ALL_THEME_TOKENS_FIELDS = {
    tokens: 'basic',
};
export const themeGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_THEME_TOKENS_FIELDS;
    if (fields === 'all')
        fields = ALL_THEME_TOKENS_FIELDS;
    return `
    name
    status
    ${fields.tokens
        ? `
      tokens {
        ${themeTokensGQLFields(fields.tokens)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=theme.fields.js.map